import React from 'react';
import DataGrid from '../components/DataGrid';

function ClientsReport({ embedded = false, refreshKey = 0, query = {} }) {
  const columns = [
    { key: 'last_name', label: 'Last Name' },
    { key: 'first_name', label: 'First Name' },
    { key: 'ei_number', label: 'EI Number' },
    { key: 'participant_id', label: 'Participant ID' },
    { key: 'open_date', label: 'Open Date' },
    { key: 'close_date', label: 'Close Date' },
    { key: 'city', label: 'City' },
    { key: 'state', label: 'State' },
  ];

  return (
    <DataGrid
      title="Clients – Summary"
      columns={columns}
      fetchUrl="clients"
      exportUrl="clients.csv"
      editable={false}
      embedded={embedded}
      refreshKey={refreshKey}
      query={query}
    />
  );
}

export default ClientsReport;
